import React from 'react';
import { Tooltip } from '@mui/material';
import LogoutIcon from '../../assets/Icons/components/LogoutIcon';
import Avatar from '../Avatar/Avatar';

type UserProfileProps = {
  isCollapsed: boolean;
  username: string;
  role: string;
  district?: string;
  isAuthenticated: boolean;
  handleLogout?: () => void;
};

const UserProfile: React.FC<UserProfileProps> = ({
  isCollapsed,
  username,
  isAuthenticated,
  handleLogout,
  role,
}) => {
  return (
    <div
      data-testid="user-profile-container"
      className={`flex ${isCollapsed ? 'flex-col space-y-2 px-0 mb-[5px]' : 'flex-row pl-1'} items-center py-3 ${!isCollapsed && 'justify-between'}`}
      style={{ borderTop: '1px solid #EBEBEB' }}
    >
      {!isCollapsed && (
        <div
          data-testid="user-profile-transition"
          className={`flex items-center ${isCollapsed ? 'justify-center mb-[14px]' : 'overflow-hidden'} transition-all ease-in-out`}
        >
          <div>
            <Avatar name={username} />
          </div>
          <div className="flex flex-grow-1 flex-col justify-between ml-3 cursor-default">
            <span className="text-sm font-semibold text-gray-550 whitespace-nowrap">
              {username}
            </span>
            <span className="capitalize text-[12px] text-gray-500">{role}</span>
          </div>
        </div>
      )}
      {isAuthenticated && (
        <Tooltip
          title="Logout"
          placement="right"
          arrow
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: '#4F4F4F',
                color: 'white',
                fontSize: '14px',
                opacity: 1,
                ['& .MuiTooltip-arrow']: { color: '#4F4F4F' },
              },
            },
          }}
        >
          <div
            onClick={handleLogout}
            className="mb-1 rounded-md h-10 flex justify-center items-center cursor-pointer"
          >
            <LogoutIcon height={18} width={18} color="#6E6E6E" hoverColor="bg-blue-950" />
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default UserProfile;
